import React, { FunctionComponent } from 'react';
import Spacer from 'src/ui/atoms/spacer';
import Translate from 'src/ui/atoms/translate';
import Text from 'src/ui/polymorphs/text';
import Segment from 'src/ui/atoms/segment';
import * as Styled from './styled';

const AddProductInfo: FunctionComponent = () => {
  return (
    <>
      <Translate name="addProduct.info.subtitle" />
      <Spacer y={6} />
      <Styled.ProductInfo>
        <Styled.Step key={1}>
          <strong>1</strong>
          <Spacer x={4} inline />
          <Translate name={`addProduct.info.steps.issuer`} />
        </Styled.Step>
        <Spacer y={2} />
        <Styled.Step key={2}>
          <strong>2</strong>
          <Spacer x={4} inline />
          <Translate name={`addProduct.info.steps.name`} />
        </Styled.Step>
        <Spacer y={2} />
        <Styled.Step key={3}>
          <strong>3</strong>
          <Spacer x={4} inline />
          <Translate name={`addProduct.info.steps.isin`} />
        </Styled.Step>
        <Spacer y={2} />
        <Styled.Step key={4}>
          <strong>4</strong>
          <Spacer x={4} inline />
          <Translate name={`addProduct.info.steps.asset`} />
        </Styled.Step>
        <Spacer y={2} />
        <Styled.Step key={5}>
          <strong>5</strong>
          <Spacer x={4} inline />
          <Translate name={`addProduct.info.steps.investment`} as="span" />
        </Styled.Step>
        <Spacer y={2} />
        <Styled.Step key={6}>
          <strong>6</strong>
          <Spacer x={4} inline />
          <Translate name={`addProduct.info.steps.nominalValue`} />
        </Styled.Step>
        <Spacer y={2} />
        <Styled.Step key={7}>
          <strong>7</strong>
          <Spacer x={4} inline />
          <Translate name={`addProduct.info.steps.terms`} />
        </Styled.Step>
      </Styled.ProductInfo>
      <Segment spacing="none" padded="none" basic={true}>
        <Text>
          <Translate name="addProduct.info.description" />
        </Text>
      </Segment>
    </>
  );
};

export default AddProductInfo;
